<template>
  <v-card :color="ui.cardColor" dark :max-width="ui.cardMaxWidth" :max-height="ui.cardMaxHeight">
    <v-card-title>
      <v-icon large left :color="ui.iconColor"> emergency </v-icon>
      <span :class="ui.textHeadline"> Risk </span>
      <v-spacer/>
      <v-btn :color="ui.btnColor" flat dark :disabled="true"
      v-if="
      !this.enableNew &&
      this.enableAccessAuthCreate('B1')
      ">
        <v-icon left> add </v-icon> new
      </v-btn>
      <RiskNew
      :data="{size: 'icon'}"
      v-if="
      this.licenceOK &&
      this.userOK &&
      this.enableNew &&
      this.enableAccessAuthCreate('B1')
      "/>
      <GeneralHelp :data="{tag: 'B1', size: 'icon', title: null}"/>
    </v-card-title>

    <v-card-text class="ml-2">
      <div :class="ui.textDescription">
        Technical and business risk analysis and management.
      </div>
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow">
        <Search :data="{title: 'Risk Search', tag: 'B1', reach: this.searchReach}"/>
        <v-spacer/>
        <GetRegisterListPage :data="{tag: 'K6', tagd: 'B1', tags: 'B1', size:'flat', check: this.checkReach}"
        v-if="this.licenceOK && this.userOK !== null"/>
      </v-list-tile>
    </v-card-actions>
  </v-card>
</template>

<script>
import RiskNew from "@/business/risk/components/RiskNew";
import Search from "@/data/search/components/Search";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import GetRegisterListPage from "@/data/register/components/GetRegisterListPage";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import GeneralHelp from "@/frame/help/components/GeneralHelp";
// import GetRegisterListPage from "@/data/register/components/GetRegisterListPage";
import { mapGetters } from "vuex";

export default {
  mixins: [apptheme, licenceFunctions, adminFunctions, accessFunctions],
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getUser", "getCurrentPage"]),
    checkReach() {
      let check = null;
      if (this.getCurrentPage === "/facilitydashoperations") {
        check = "link.fdid";
      } else {
        check = null;
      }
      return check;
    },
    searchReach() {
      let info = "";
      if (this.getCurrentPage === "/facilitydashoperations") {
        info = "facility";
      } else {
        info = "company";
      }
      return info;
    }
  },
  components: {
    GetRegisterListPage,
    RiskNew,
    GeneralHelp,
    Search
  },
  mounted() {
    setTimeout(() => {
      this.enableNew = true;
    }, 500);
  },
  data() {
    return {
      valid: true,
      enableNew: false
    };
  }
};
</script>
